import { useApiClient } from "../../../api-client";

const useVerificationEmail = () => {
  const { post } = useApiClient();

  return {
    postVerificationEmail: async (email: string) =>
      await post("/v1/verification-email", { email }),
  };
};

export { useVerificationEmail };
